import GeneratedCalendarStore from "./generated/GeneratedCalendarStore"

class CalendarStore extends GeneratedCalendarStore {

}

export const calendarStore = new CalendarStore()
